import { apiGet, apiPost, apiPatch, apiDelete } from './httpClient'

// Users
export async function listUsers(params = {}, signal) {
	const query = new URLSearchParams(params).toString()
	const data = await apiGet(`/users/${query ? `?${query}` : ''}`, { signal })
	return Array.isArray(data) ? data : (data.results || [])
}

export async function createUser(data) {
	return apiPost('/users/', data)
}

export async function updateUser(id, data) {
	return apiPatch(`/users/${id}/`, data)
}

export async function deleteUser(id) {
	await apiDelete(`/users/${id}/`)
	return true
}

// Profiles
export async function listProfiles(params = {}, signal) {
	const query = new URLSearchParams(params).toString()
	const data = await apiGet(`/profiles/${query ? `?${query}` : ''}`, { signal })
	return Array.isArray(data) ? data : (data.results || [])
}

export async function createProfile(data) {
	return apiPost('/profiles/', data)
}

export async function updateProfile(id, data) {
	return apiPatch(`/profiles/${id}/`, data)
}

export async function deleteProfile(id) {
	await apiDelete(`/profiles/${id}/`)
	return true
}

// Permissions
export async function listPermissions(params = {}, signal) {
	const query = new URLSearchParams(params).toString()
	const data = await apiGet(`/permissions/${query ? `?${query}` : ''}`, { signal })
	return Array.isArray(data) ? data : (data.results || [])
}

// Secretarias
export async function listSecretarias(params = {}, signal) {
	const query = new URLSearchParams(params).toString()
	const data = await apiGet(`/secretarias/${query ? `?${query}` : ''}`, { signal })
	return Array.isArray(data) ? data : (data.results || [])
}

// Password Management
export async function resetUserPassword(userId) {
	return apiPost(`/users/${userId}/reset_password/`)
}

export async function changePassword(oldPassword, newPassword) {
	return apiPost('/users/change_password/', {
		old_password: oldPassword,
		new_password: newPassword
	})
}
